"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useActiveRoute = exports.ActiveRouteProvider = void 0;

var _react = require("react");

var _util = require("./util");

const ActiveRouteContext = (0, _util.createNamedContext)('ActiveRoute');
const ActiveRouteProvider = ActiveRouteContext.Provider;
exports.ActiveRouteProvider = ActiveRouteProvider;

const useActiveRoute = () => {
  const context = (0, _react.useContext)(ActiveRouteContext);

  if (context === undefined) {
    throw new Error('useActiveRoute must be used within a ActiveRouteContext');
  }

  return context.activeRoute;
};

exports.useActiveRoute = useActiveRoute;